/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Ptz_RightInputs */

const vi_grower_area_camera_ptz_right = /** @type {(inputs: Grower_Area_Camera_Ptz_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay phải`)
};

/**

* @param {Grower_Area_Camera_Ptz_RightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_ptz_right = /** @type {((inputs?: Grower_Area_Camera_Ptz_RightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Ptz_RightInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_ptz_right(inputs)
});